const gridTemplateColumns = {
    name: "grid-template-columns",
    path: "/grid-template-columns",
    title: "grid-template-columns",
    description: "Utilities for specifying the columns in a grid layout.",
    value: {
        "grid-template-columns": {
            "grid-columns-<number>": "repeat(<number>, minmax(0, 1fr))",
            "grid-columns-none": "none",
            "grid-columns-subgrid": "subgrid",
            "grid-columns-[<value>]": "<value>",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-columns-4 gap-4">
  <div>01</div>
  <!-- ... -->
  <div>09</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid grid-columns-4 gap-4">
  <div>01</div>
  <!-- ... -->
  <div>05</div>
  <div class="col-span-3 grid grid-columns-subgrid gap-4">
    <div class="col-start-2">06</div>
  </div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid-columns-[200px_minmax(150px,_1fr)_100px] ...">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-cols-<var>&lt;number&gt;</var></code>
                  utilities like grid-cols-2 and grid-cols-4 to create grids with
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid md:grid-columns-4 grid-columns-2 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">09</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-cols-subgrid</code>
                  utility to adopt the column tracks defined by the item's parent:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-columns-4 gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-blue-200 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-blue-200 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-blue-200 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-blue-200 p-4">04</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-blue-200 p-4">05</div>
                    <div class="col-span-3 grid grid-columns-subgrid gap-4">
                        <div></div>
                         <div class="flex col-start-2 h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                        <div></div>
                    </div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-cols-[<value>]</code>
                  syntax to set the columns based on a completely custom value:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-columns-[200px_minmax(150px,_1fr)_100px] gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                    <div class="flex h-14 flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">09</div>
                </div>
            </div>
            `
        },
    ]
};

export default gridTemplateColumns;

<div className="sr-only md:grid-columns-4 grid-columns-2 grid-columns-[200px_minmax(150px,_1fr)_100px] grid-columns-4 col-span-3 col-start-2  grid-columns-subgrid bg-color-blue-200">



</div>